import React from 'react';

import { MemberAvatar } from '@/components/MemberAvatar';
import { useAccountRecord } from './AccountRecordContext';
import { BandHead } from './primitives';

/**
 * AR-380 — the advisor's photo.
 *
 * The GEM progress panel that used to sit beside the record here is gone
 * (D-ACCT-26): GEM Status is a page of its own in this column now, so the panel
 * was a summary of the page one row below it.
 *
 * AR-409: rendered through the shared `MemberAvatar`, so the Account center
 * shows the same photo / initials-on-theme-colour circle as the sidebar menu.
 */

const SIZES = {
  sm: 'h-8 w-8 text-[13px]',
  md: 'h-[54px] w-[54px] text-xl',
  lg: 'h-[54px] w-[54px] text-xl',
  hero: 'h-24 w-24 text-3xl',
} as const;

export const AccountIdentityAvatar: React.FC<{
  size?: keyof typeof SIZES;
  className?: string;
}> = ({ size = 'md', className }) => {
  const { record } = useAccountRecord();

  return (
    <MemberAvatar
      photoUrl={record.pub.photo}
      firstName={record.you.first}
      lastName={record.you.last}
      className={[SIZES[size], className].filter(Boolean).join(' ')}
    />
  );
};

export { BandHead };
